import { useState } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import Button from '../../components/base/Button';
import { useCreateDivisionMutation } from './divisions.api';
import { useNavigate } from 'react-router-dom';

const CreateDivision = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const [createDivision, { isLoading }] = useCreateDivisionMutation();

  const organizationId = localStorage.getItem('organizationId') || '';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!title.trim()) {
      alert('Division name is required');
      return;
    }

    if (!organizationId) {
      alert('Organization ID not found. Please log in again.');
      return;
    }

    try {
      await createDivision({
        title,
        organizationId,
        description
      }).unwrap();

      alert('Division created successfully!');
      navigate('/divisions/view-all');
    } catch (error: any) {
      console.error('Failed to create division:', error);
      alert(error?.data?.message || 'Failed to create division. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate('/divisions/view-all');
  };

  return (
    <div>
      {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
      <div className="mb-9">
        <Row className="align-items-center justify-content-between g-3 mb-4">
          <Col md="auto">
            <h2 className="mb-0">Create New Division</h2>
          </Col>
        </Row>

        <Card>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row className="g-3">
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>
                      Division Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter division name"
                      value={title}
                      onChange={e => setTitle(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Enter division description (optional)"
                      value={description}
                      onChange={e => setDescription(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col xs={12}>
                  <div className="d-flex gap-2 justify-content-end">
                    <Button variant="phoenix-secondary" onClick={handleCancel} disabled={isLoading}>
                      Cancel
                    </Button>
                    <Button variant="phoenix-primary" type="submit" disabled={isLoading}>
                      {isLoading ? 'Creating...' : 'Create Division'}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default CreateDivision;
